<!-- site -->
<template>
  <div>
    <!-- carrossel -->
    <div :key="carousel">
      <div class="relative w-full">
        <!-- Carousel wrapper -->
        <div
          v-if="carousel"
          class="relative h-[70vh] overflow-hidden rounded-lg md:h-[90vh] z-10"
          id="default-carousel"
          data-carousel="slide"
        >
          <div
            class="hidden duration-700 ease-in-out bg-cover bg-center"
            data-carousel-item
            v-for="item in carousel"
            :key="item"
            :class="[
              `bg-[url(${fileUrl + item})]`
            ]"
          >
          </div>
        </div>

        <!-- v-else -->
        <!-- <div
          class="relative h-[70vh] overflow-hidden rounded-lg md:h-[90vh] z-10"
        >
          <img
            class="hidden duration-700 ease-in-out bg-cover bg-center"
            :src="banner"
          >
          </img>
        </div> -->

        <div class="bg-gray-800 absolute inset-0 z-10 opacity-20"></div>

        <!-- jumbotron -->
        <JumbotronHome
          :subTitle="mainDesc"
          :mtSub="true"
        >
          <template #principal>
            <img
              class="text-4xl font-extrabold tracking-tight leading-none text-gray-900 md:text-5xl lg:text-6xl dark:text-white"
              width="450"
              height="450"
              :src="appLogo"
            />
          </template>

          <template #button>
            <div
              class="flex flex-col space-y-4 sm:flex-row sm:justify-center sm:space-y-0 cursor-pointer"
            >
              <router-link
                to="/auth"
                class="cursor-pointer inline-flex justify-center items-center py-2 px-10 text-base font-bold tracking-wide text-white bg-[#d20a0a] border-2 border-red-700 hover:bg-white hover:text-red-700 transition-colors duration-300"
              >
                <label
                  class="pb-3 mt-2 text-3xl uppercase font-berthold-force font-bold tracking-wide cursor-pointer"
                >
                  ACESSAR AGORA
                </label>
              </router-link>
            </div>
          </template>
        </JumbotronHome>

      </div>
    </div>

    <!-- download -->
    <section
      class="relative bg-fixed bg-center bg-cover md:h-auto h-[70vh]"
      :style="{
        backgroundImage: `url(${bgDownload})`,
      }"
    >
      <div class="absolute inset-0 bg-black/70 z-0"></div>

      <main class="relative z-[1] flex-col w-full">
        <section class="w-full flex justify-center">
          <div class="md:w-1/2 w-full">
            <TitleSection
              :customWTitle="true"
              class="text-white"
              :title="downloadConf?.desc"
            />
          </div>
        </section>

        <div
          class="flex flex-col justify-center items-center p-1 font-berthold-force w-full md:h-[80vh]"
        >
          <div>
            <img
              :src="downloadConf?.image != null ? fileUrl + downloadConf?.image : baseDownload"
              alt="download-now"
              width="800"
              height="800"
            />
          </div>

          <div>
            <div
              class="flex flex-col space-y-4 sm:flex-row sm:justify-center sm:space-y-0 cursor-pointer"
            >
              <button
                @click.prevent="triggerPwaInstall"
                class="cursor-pointer inline-flex justify-center items-center py-2 px-10 text-base font-bold tracking-wide text-white bg-[#d20a0a] border-2 border-red-700 hover:bg-white hover:text-red-700 transition-colors duration-300"
              >
                <label
                  class="pb-3 mt-2 text-3xl uppercase font-berthold-force font-bold tracking-wide cursor-pointer"
                >
                  BAIXE O APP
                </label>
              </button>
            </div>
          </div>
        </div>
      </main>
    </section>

    <!-- descrições -->
    <section class="font-berthold-force">
      <div>
        <TitleSection :title="'COMO NUNCA ANTES'">
          <template #tag>
            <p
              class="uppercase text-[#D20A0A] text-lg font-berthold-force tracking-widest"
            >
              EXPERIMENTE ESPORTES DE COMBATE
            </p>
          </template>
        </TitleSection>
      </div>

      <section class="w-full py-10 px-4">
        <div
          class="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8"
        >
          <!-- Card 1 -->
          <div class="text-center">
            <img
              :src="fileUrl + highlights?.first?.image"
              :alt="highlights?.first?.selectedFileName"
              class="rounded mb-4 w-[506px] h-[290px]"
            />
            <h3 class="text-2xl font-extrabold text-red-700 uppercase mb-2">
              {{ highlights?.first?.title }}
            </h3>
            <p class="text-lg text-gray-700">
              {{ highlights?.first?.desc }}
            </p>
          </div>

          <!-- Card 2 -->
          <div class="text-center">
            <img
              :src="fileUrl + highlights?.second?.image"
              :alt="highlights?.second?.selectedFileName"
              class="rounded mb-4 w-[506px] h-[290px]"
            />
            <h3 class="text-2xl font-extrabold text-red-700 uppercase mb-2">
              {{ highlights?.second?.title }}
            </h3>
            <p class="text-lg text-gray-700">
              {{ highlights?.second?.desc }}
            </p>
          </div>

          <!-- Card 3 -->
          <div class="text-center">
            <img
              :src="fileUrl + highlights?.third?.image"
              :alt="highlights?.third?.selectedFileName"
              class="rounded mb-4 w-[506px] h-[290px]"
            />
            <h3 class="text-2xl font-extrabold text-red-700 uppercase mb-2">
              {{ highlights?.third?.title }}
            </h3>
            <p class="text-lg text-gray-700">
              {{ highlights?.third?.desc }}
            </p>
          </div>
        </div>
      </section>
    </section>

    <!-- card principal -->
    <section
      id="ppv"
      class="relative bg-fixed bg-center bg-cover h-[95vh] flex items-center justify-center"
      :class="[`bg-[url(${fileUrl}${mainEvent?.event?.banner})]`]"
    >
      <div class="absolute inset-0 bg-black/50"></div>

      <JumbotronHome
        :title="'próximo evento da number one'"
        :subTitle="formatDateFull(mainEvent?.event?.starts_at)"
      >
        <template #tag>
          <p
            class="font-ufc-force text-[#D20A0A] text-xl md:text-2xl italic uppercase font-bold w-full mt-8 -mb-3"
          >
            {{ mainEvent?.event?.tag }}
          </p>
        </template>

        <template #principal>
          <div class="font-berthold-force italic font-bold text-white">
            <h2
              class="text-5xl md:text-7xl font-extrabold my-4 tracking-widest"
            >
              {{ mainEvent?.event?.title }}
            </h2>
          </div>
        </template>

        <template #descript>
          <div
            class="font-extralight text-white my-3 tracking-wide text-2xl font-berthold-force w-full md:w-1/2"
          >
            {{ mainEvent?.event?.description }}
          </div>
        </template>

        <template #button>
          <div
            class="flex flex-col space-y-4 sm:flex-row sm:justify-center sm:space-y-0 cursor-pointer"
          >
            <router-link
              :to="`/purchase/${mainEvent?.event?.id}/event`"
              class="cursor-pointer inline-flex justify-center items-center py-2 px-10 text-base font-bold tracking-wide text-white bg-[#d20a0a] border-2 border-red-700 hover:bg-white hover:text-red-700 transition-colors duration-300"
            >
              <label
                class="pb-3 mt-2 text-3xl uppercase font-berthold-force font-bold tracking-wide cursor-pointer"
              >
                {{
                  mainEvent?.event?.price == null
                  ? 'ASSISTIR AGORA'
                  : 'COMPRAR INGRESSO'
                }}
              </label>
            </router-link>
          </div>
        </template>
      </JumbotronHome>
    </section>
  </div>
</template>

<script setup>
import JumbotronHome from './../components/__partials/JumbotronHome'
import TitleSection from './../components/__partials/TitleSection'
import bgDownload from '@/assets/bgDownload.webp'
import { computed, onBeforeMount, ref } from 'vue'
import { dataShared } from '../store'
import { deferredPrompt } from '@/installPrompt'
import SharedService from '../services/shared'
import defaultLogo from '@/assets/logo/logo-rs.png'
import moment from 'moment'
import 'moment/locale/pt-br'

const fileUrl = process.env.VUE_APP_IMAGE_SERVE + 'storage/'
const banner = computed(() => dataShared.getters.getAppLogo)

const carousel = ref([])
const mainDesc = ref(null)
const mainEvent = computed(() => dataShared.getters.getMainEvent)
const highlights = ref({})
const bannerLogin = computed(() => dataShared.getters.bannerLogin)
const downloadConf = computed(() => dataShared.getters.getDownloadConf)
const baseDownload = require('./../../assets/downloadNow.png')

const appLogo = computed(() => {
  return dataShared.getters.getLogo || defaultLogo
})

function triggerPwaInstall () {
  if (deferredPrompt) {
    deferredPrompt.prompt()

    deferredPrompt.userChoice.then((choiceResult) => {
      if (choiceResult.outcome === 'accepted') {
        console.log('APP instalado')
      } else {
        console.log('APP recusado')
      }
    })
  } else {
    alert('Você já possui este app')
  }
}

function formatDateFull (dateString) {
  return moment(dateString).format('dddd, D [de] MMMM [de] YYYY')
}

async function getCarousel () {
  await SharedService.getCarroussel()
    .then((res) => {
      carousel.value = res.data.carousel
    })
    .catch((err) => {
      console.log(err)
    })
}

async function getMainDesc () {
  await SharedService.getMainDesc()
    .then((res) => {
      mainDesc.value = res.data.mainDesc
    })
    .catch((err) => {
      console.log(err)
    })
}

async function getMainEvent () {
  await SharedService.getMainEvent()
    .then((res) => {
      dataShared.dispatch('setMainEvent', res.data.mainEvent)
    })
    .catch((err) => {
      console.log(err)
    })
}

async function getHighlights () {
  await SharedService.getHighlights()
    .then((res) => {
      highlights.value = res.data.highlights
    })
    .catch((err) => {
      console.log(err)
    })
}

async function getDescriptionsDownload () {
  await SharedService.getDescriptionsDownload()
    .then((res) => {
      dataShared.dispatch(
        'setDownloadConf',
        res.data
      )
    })
    .catch((err) => {
      console.log(err)
    })
}

onBeforeMount(() => {
  Promise.all([
    getCarousel(),
    getMainDesc(),
    getMainEvent(),
    getHighlights(),
    getDescriptionsDownload(),
  ])
})
</script>

<style lang="scss"></style>
